import { CSSProperties, FC, PropsWithChildren } from 'react';

import { TColorProp } from 'styled-components';

import { satoshi, sora } from '~/common/styles/fonts';

import { Container, TTitleSize } from './styles';

interface ITitleProps extends PropsWithChildren {
  size: TTitleSize;
  color?: TColorProp;
  style?: CSSProperties;
  href?: string;
  sora?: boolean;
}

export const Title: FC<ITitleProps> = ({
  size,
  color = 'neutral100',
  children,
  style,
  href,
  sora: soraFont = false,
}) => {
  return (
    <Container
      $size={size}
      as={size}
      $color={color}
      className={soraFont ? sora.className : satoshi.className}
      style={style}
      {...(href && {
        as: 'a',
        href,
      })}
    >
      {children}
    </Container>
  );
};
